module.exports = {"soft_hint":"By submitting your email you will agree on express registration and the following data processing","soft_hint_link":"terms","register_manually":"You can also register","register_manually_link":"manually","title":"In order to become a customer, I agree to the following","edit":"Edit","learn":"learn more","confirm":"I Confirm","select_all":"Select all","variant_MGA":{"title":"I agree to the following"},"variant_MGA-otp":{"title":"I agree to the following"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/GDPR.json
// module id = 507
// module chunks = 245 992